import { useEffect, useState } from "react";
import { analytics } from "./analytics.js";
import "./analytics-consent.css";

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(() => analytics().getConsent());
  const [open, setOpen] = useState(!choice);

  useEffect(() => {
    if (choice === "accepted") analytics().initialize();
  }, [choice]);

  function choose(value) {
    analytics().saveConsent(value);
    setChoice(value);
    setOpen(false);
  }

  return open ? (
    <aside className="analytics-consent" aria-label="Analytics preferences">
      <div>
        <strong>Your privacy choices</strong>
        <p>With your permission, we use Google Analytics and Microsoft Clarity to understand visits and improve this website. We do not send walkthrough form answers to these tools. <a href="/privacy">Privacy policy</a></p>
      </div>
      <div className="analytics-consent-actions">
        <button type="button" onClick={() => choose("rejected")}>Reject analytics</button>
        <button type="button" className="analytics-consent-accept" onClick={() => choose("accepted")}>Accept analytics</button>
      </div>
    </aside>
  ) : (
    <button type="button" className="analytics-preferences" onClick={() => setOpen(true)}>Analytics preferences</button>
  );
}
